// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Grid, TextField, Button, Box, Typography,
//   InputAdornment, MenuItem
// } from "@mui/material";
// import PersonIcon from "@mui/icons-material/Person";
// import EmailIcon from "@mui/icons-material/Email";
// import PhoneIcon from "@mui/icons-material/Phone";
// import LockIcon from "@mui/icons-material/Lock";
// import BadgeIcon from "@mui/icons-material/Badge";
// import BusinessIcon from "@mui/icons-material/Business"; // Icon for Site
// import { ToastContainer, toast } from "react-toastify";
// import 'react-toastify/dist/ReactToastify.css';
// import axios from "axios";
// import "./CreateSupervisor.css";

// const CreateSupervisor = () => {
//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone_no: "",
//     password: "",
//     customer_id: "",
//     site_id: "", // Added to store selected site
//   });

//   const [sites, setSites] = useState([]); // To store sites fetched from API
//   const [errors, setErrors] = useState({});
//   const navigate = useNavigate();
// // ✅ Name: only alphabets, 2–10 chars
// const nameRegex = /^[A-Za-z]{2,10}$/;
// // ✅ Email: standard
// const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// // ✅ Phone: starts from 6–9, exactly 10 digits
// const phoneRegex = /^[6-9]\d{9}$/;


//   const API_URL = process.env.REACT_APP_API_DJANGO_URL;


//   // Generates a strong password with letters, numbers, and special characters
// const generatePassword = (length = 10) => {
//   const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
//   let password = "";
//   for (let i = 0; i < length; i++) {
//     password += chars.charAt(Math.floor(Math.random() * chars.length));
//   }
//   return password;
// };

//   // 1. Fetch sites on component load
//   useEffect(() => {
//     const fetchSites = async () => {
//       try {
//         const token = localStorage.getItem("accessToken");
//         const customerId = localStorage.getItem("customer_id");
//         if (!customerId) return;

//         const response = await axios({
//           url: `${API_URL}/api/get_customer_availablesites/${customerId}/`,
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           data: {}, // force POST/GET compatibility with Content-Type
//         });

//         const formattedData = response.data.data.map((site, index) => ({
//           id: index + 1,
//           site_id: site.site_id,
//           name: site.name,
//         }));

//         setSites(formattedData);
//       } catch (error) {
//         console.error("Error fetching sites:", error);
//         toast.error("Failed to load sites");
//       }
//     };

//     fetchSites();
//   }, [API_URL]);


//  const validateForm = () => {
//   const tempErrors = {};

//   const firstName = formData.first_name.trim();
//   const lastName = formData.last_name.trim();
//   const email = formData.email.trim();
//   const phone = formData.phone_no.trim();

//   // ✅ First Name
//   if (!firstName) {
//     tempErrors.first_name = "First name is required";
//   } else if (!nameRegex.test(firstName)) {
//     tempErrors.first_name =
//       "Only alphabets, 2–10 characters, no spaces or numbers";
//   }

//   // ✅ Last Name
//   if (!lastName) {
//     tempErrors.last_name = "Last name is required";
//   } else if (!nameRegex.test(lastName)) {
//     tempErrors.last_name =
//       "Only alphabets, 2–10 characters, no spaces or numbers";
//   }

//   // ✅ Email
//   if (!email) {
//     tempErrors.email = "Email is required";
//   } else if (!emailRegex.test(email)) {
//     tempErrors.email = "Invalid email format";
//   }

//   // ✅ Phone
//   if (!phone) {
//     tempErrors.phone_no = "Phone number is required";
//   } else if (!phoneRegex.test(phone)) {
//     tempErrors.phone_no =
//       "Must be 10 digits and start from 6–9";
//   }

//   // ✅ Site (optional → uncomment if required)
//   // if (!formData.site_id) {
//   //   tempErrors.site_id = "Please assign a site";
//   // }

//   setErrors(tempErrors);
//   return Object.keys(tempErrors).length === 0;
// };



// const handleChange = (e) => {
//   let { name, value } = e.target;

//   // ✅ Names: only alphabets
//   if (name === "first_name" || name === "last_name") {
//     value = value.replace(/[^A-Za-z]/g, "");
//   }

//   // ✅ Email: remove starting space
//   if (name === "email") {
//     value = value.replace(/^\s+/, "");
//   }

//   // ✅ Phone: only digits
//   if (name === "phone_no") {
//     value = value.replace(/\D/g, "").slice(0, 10);
//   }

//   setFormData((prev) => ({
//     ...prev,
//     [name]: value,
//   }));

//   // ✅ Real-time validation
//   let error = "";

//   if (name === "first_name" || name === "last_name") {
//     if (!value) {
//       error = `${name === "first_name" ? "First" : "Last"} name is required`;
//     } else if (!nameRegex.test(value)) {
//       error = "Only alphabets (2–10), no spaces";
//     }
//   }

//   if (name === "email") {
//     if (value && !emailRegex.test(value)) {
//       error = "Invalid email";
//     }
//   }

//   if (name === "phone_no") {
//     if (value && !phoneRegex.test(value)) {
//       error = "Must start from 6–9 and be 10 digits";
//     }
//   }

//   setErrors((prev) => ({
//     ...prev,
//     [name]: error,
//   }));
// };


// const handleFormSubmit = async (e) => {
//   e.preventDefault();

//   if (!validateForm()) return;

//   try {
//     const token = localStorage.getItem("accessToken");
//     const customerId = localStorage.getItem("customer_id");

//     // Generate password
//     const password = generatePassword(10);

//     // 1️⃣ Create Supervisor
//     const createResp = await axios.post(`${API_URL}/api/create_supervisor/`, {
//       email: formData.email,
//       first_name: formData.first_name,
//       last_name: formData.last_name,
//       phone_no: formData.phone_no,
//       // address: "",
//       customer_id: customerId,
//       password: password,
//       site_id: formData.site_id || null
//     }, {
//       headers: {
//         "Content-Type": "application/json",
//         "Accept": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     toast.success("Supervisor created successfully!");


//     // Reset form
//     setFormData({
//       first_name: "", last_name: "", email: "",
//       phone_no: "", password: "", customer_id: "", site_id: ""
//     });

//   } catch (error) {
//     console.error("Error:", error);
//     toast.error(error.response?.data?.error || "Failed to create supervisor");
//   }
// };

//   return (
//     <Box component="form" className="create-site-form-container" onSubmit={handleFormSubmit}>

//       <Grid container spacing={3}>
//         {/* Name Fields */}
//         <Grid item xs={12} sm={6}>
//           <TextField
//             className="create-site-input"
//             label="First Name"
//             name="first_name"
//             value={formData.first_name}
//             onChange={handleChange}
//             required
//             error={!!errors.first_name}
//             helperText={errors.first_name}

//           />
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <TextField
//             className="create-site-input"
//             label="Last Name"
//             name="last_name"
//             value={formData.last_name}
//             onChange={handleChange}
//             required
//              error={!!errors.last_name}
//             helperText={errors.last_name || ""}
//           />
//         </Grid>


//         <Grid item xs={12}>
//           <TextField
//             className="create-site-input"
//             label="Email Address"
//             name="email"
//             type="email"
//             value={formData.email}
//             onChange={handleChange}
//             required
//             error={!!errors.email}
//             helperText={errors.email}

//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             className="create-site-input"
//             label="Phone Number"
//             name="phone_no"
//             value={formData.phone_no}
//             onChange={handleChange}
//             required
//             error={!!errors.phone_no}
//             helperText={errors.phone_no}

//           />
//         </Grid>


//         {/* SITE DROPDOWN - New Field */}
//         <Grid item xs={12}>
//           <TextField
//             select
//             className="create-site-input"
//             label="Assign Site"
//             name="site_id"
//             value={formData.site_id}
//             onChange={handleChange}
//             error={!!errors.site_id}
//             helperText={errors.site_id || "Select the site this supervisor will manage"}
//           >
//             {sites.length > 0 ? (
//               sites.map((site) => (
//                 <MenuItem key={site.id} value={site.site_id}>
//                   {site.name}
//                 </MenuItem>
//               ))
//             ) : (
//               <MenuItem disabled>No sites available</MenuItem>
//             )}
//           </TextField>
//         </Grid>



//       </Grid>

//       <Box className="submit-btn-wrapper">
//         <Button variant="outlined" className="submit-btn cancel-btn" onClick={() => navigate("/dashboard")}>
//           Cancel
//         </Button>
//         <Button type="submit" variant="contained" className="submit-btn">
//           Create Supervisor
//         </Button>
//       </Box>

//       <ToastContainer position="top-right" autoClose={3000} />
//     </Box>
//   );
// };

// export default CreateSupervisor;







import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid, TextField, Button, Box, Typography,
  InputAdornment, MenuItem
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LockIcon from "@mui/icons-material/Lock";
import BadgeIcon from "@mui/icons-material/Badge";
import BusinessIcon from "@mui/icons-material/Business"; // Icon for Site
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import "./CreateSupervisor.css";
import apiService from "../../utils/apiservice";

const CreateSupervisor = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_no: "",
    password: "",
    customer_id: "",
    site_id: "", // Added to store selected site
  });

  const [sites, setSites] = useState([]); // To store sites fetched from API
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  // ✅ Name: only alphabets, 2–10 chars
  const nameRegex = /^[A-Za-z]{2,20}$/;
  // ✅ Email: standard
  const emailRegex =
  /^(?!.*\.\.)(?!\.)([A-Za-z0-9._%+-]+)@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  // ✅ Phone: starts from 6–9, exactly 10 digits
  const phoneRegex = /^[6-9]\d{9}$/;

  const API_URL = process.env.REACT_APP_API_DJANGO_URL;


  // Generates a strong password with letters, numbers, and special characters
  const generatePassword = (length = 10) => {
    const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  // 1. Fetch sites on component load
  useEffect(() => {
    const fetchSites = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const customerId = localStorage.getItem("customer_id");
        if (!customerId) return;

        // const response = await axios({
        //   url: `${API_URL}/api/get_customer_availablesites/${customerId}/`,
        //   method: "GET",
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //     Accept: "application/json",
        //     "Content-Type": "application/json",
        //   },
        //   data: {}, // force POST/GET compatibility with Content-Type
        // });

        const response = await apiService.get(
          `/api/get_customer_availablesites/${customerId}/`,
          {
            data: {}, // keep because your backend needs it
          }
        );

        const formattedData = response.data.data.map((site, index) => ({
          id: index + 1,
          site_id: site.site_id,
          name: site.name,
        }));

        setSites(formattedData);
      } catch (error) {
        console.error("Error fetching sites:", error);
        toast.error("Failed to load sites");
      }
    };

    fetchSites();
  }, [API_URL]);


  const validateForm = () => {
    const tempErrors = {};

    const firstName = formData.first_name.trim();
    const lastName = formData.last_name.trim();
    const email = formData.email.trim();
    const phone = formData.phone_no.trim();

    // ✅ First Name
    if (!firstName) {
      tempErrors.first_name = "First name is required";
    } else if (!nameRegex.test(firstName)) {
      tempErrors.first_name =
        "Only alphabets, 2–20 characters, no spaces or numbers";
    }

    // ✅ Last Name
    if (!lastName) {
      tempErrors.last_name = "Last name is required";
    } else if (!nameRegex.test(lastName)) {
      tempErrors.last_name =
        "Only alphabets, 2–20 characters, no spaces or numbers";
    }

    // ✅ Email
if (!email) {
  tempErrors.email = "Email is required";
}

else if (email.length < 2 || email.length > 50) {
  tempErrors.email = "Email must be between 2 and 50 characters";
}

else if (email.includes("..")) {
  tempErrors.email = "Multiple dots are not allowed";
}

else if (
  email.startsWith(".") ||
  email.endsWith(".")
) {
  tempErrors.email = "Dot not allowed at start/end";
}

else if (!emailRegex.test(email)) {
  tempErrors.email = "Invalid email format";
}

    // ✅ Phone
    if (!phone) {
      tempErrors.phone_no = "Phone number is required";
    } else if (!phoneRegex.test(phone)) {
      tempErrors.phone_no =
        "Must be 10 digits and start from 6–9";
    }

    // ✅ Site (optional → uncomment if required)
    // if (!formData.site_id) {
    //   tempErrors.site_id = "Please assign a site";
    // }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };



  const handleChange = (e) => {
    let { name, value } = e.target;

    // ✅ Names: only alphabets
    if (name === "first_name" || name === "last_name") {
      value = value.replace(/[^A-Za-z]/g, "");
    }

    // ✅ Email: remove starting space
    if (name === "email") {
      value = value.replace(/^\s+/, "");
    }

    // ✅ Phone: only digits
    if (name === "phone_no") {
      value = value.replace(/\D/g, "").slice(0, 10);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // ✅ Real-time validation
    let error = "";

    if (name === "first_name" || name === "last_name") {
      if (!value) {
        error = `${name === "first_name" ? "First" : "Last"} name is required`;
      } else if (!nameRegex.test(value)) {
        error = "Only alphabets (2–20), no spaces";
      }
    }

    if (name === "email") {
  if (value.length > 50) {
    error = "Email must not exceed 50 characters";
  } else if (value.length >= 2 && !emailRegex.test(value)) {
    error = "Invalid email format";
  }
}
    if (name === "phone_no") {
      if (value && !phoneRegex.test(value)) {
        error = "Must start from 6–9 and be 10 digits";
      }
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };


  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const token = localStorage.getItem("accessToken");
      const customerId = localStorage.getItem("customer_id");


      const createResp = await apiService.post(
        `/api/create_supervisor/`,
        {
          email: formData.email,
          first_name: formData.first_name,
          last_name: formData.last_name,
          phone_no: formData.phone_no,
          customer_id: customerId,
          // password: password,
          site_id: formData.site_id || null,
        }
      );

      toast.success("Supervisor created successfully!");


      // Reset form
      setFormData({
        first_name: "", last_name: "", email: "",
        phone_no: "", password: "", customer_id: "", site_id: ""
      });

    } catch (error) {
      console.error("Error:", error);
      toast.error(error.response?.data?.error || "Failed to create supervisor");
    }
  };

  return (
    <Box component="form" className="create-site-form-container" onSubmit={handleFormSubmit}>

      <Grid container spacing={3}>
        {/* Name Fields */}
        <Grid item xs={12} sm={6}>
          <TextField
            className="create-site-input"
            label="First Name"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            required
            error={!!errors.first_name}
            helperText={errors.first_name}

          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            className="create-site-input"
            label="Last Name"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            required
            error={!!errors.last_name}
            helperText={errors.last_name || ""}
          />
        </Grid>


        <Grid item xs={12}>
          <TextField
            className="create-site-input"
            label="Email Address"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === " ") e.preventDefault();
            }}
            required
            error={!!errors.email}
            helperText={errors.email}

          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            className="create-site-input"
            label="Phone Number"
            name="phone_no"
            value={formData.phone_no}
            onChange={handleChange}
            required
            error={!!errors.phone_no}
            helperText={errors.phone_no}

          />
        </Grid>


        {/* SITE DROPDOWN - New Field */}
        <Grid item xs={12}>
          <TextField
            select
            className="create-site-input"
            label="Assign Site"
            name="site_id"
            value={formData.site_id}
            onChange={handleChange}
            error={!!errors.site_id}
            helperText={errors.site_id || "Select the site this supervisor will manage"}
          >
            {sites.length > 0 ? (
              sites.map((site) => (
                <MenuItem key={site.id} value={site.site_id}>
                  {site.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No sites available</MenuItem>
            )}
          </TextField>
        </Grid>



      </Grid>

      <Box className="submit-btn-wrapper">
        <Button variant="outlined" className="submit-btn cancel-btn" onClick={() => navigate("/dashboard")}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" className="submit-btn">
          Create Supervisor
        </Button>
      </Box>

      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default CreateSupervisor;